import axios from '@/api/config';

const rechargeRule = {
  addRechargeRule(data) {
    return axios.post(`${process.env.BASE_URL}/rechargeRule/addRechargeRule`, data);
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/rechargeRule/pageList`, data);
  },
  deleteRechargeRule(data) {
    return axios.put(`${process.env.BASE_URL}/rechargeRule/deleteRechargeRule`, data);
  },
  getRechargeRuleList(data) {
    return axios.get(`${process.env.BASE_URL}/rechargeRule/getRechargeRuleList`, {params: data});
  },
}

export default rechargeRule;



// WEBPACK FOOTER //
// ./src/api/rechargeRule.js